module.exports = __webpack_public_path__ + "static/media/7.413e4e81.jpg";